<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="tkkcList" data-vv-as="课程" name="kcId"  text-field="kcmc" value-field="id" v-model="query.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)" placeholder="-课程筛选-"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>
                    <!--题库名称-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">题库名称</label>
                            <div class="col-sm-9">
                                <input type="text" v-model="query.tkmcWord" name="tkmcWord" class="form-control" placeholder="">
                            </div>
                        </div>
                    </div>
                    <!--按钮-->
                    <div :class="js=='YWGLY' ? 'col-sm-6' : 'col-sm-12'">
                        <div class="pull-right">
                            <button   @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>搜索</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<QuesBankViewQues ref="QuesBankViewQues"></QuesBankViewQues>
		<QuesBankEdit ref="QuesBankEdit"></QuesBankEdit>
    </div>
</template>
<script>


    /**
     * 题库列表
     */
    import tableMixin from '@/mixins/table.js';  //表格
    import QuesBankEdit from './QuesBankEdit.vue';   //修改
    import QuesBankViewQues from './QuesBankViewQues.vue';  //预览试题

    export default {
        mixins: [tableMixin],
        name:"QuesBankList",
		components: {
			QuesBankViewQues,
			QuesBankEdit
		},
        data:function(){
            return {
                js:this.$store.state.user.js,
                ztList: [],//状态
                tkkcList:[],//课程下拉
                ssjgList:[],//所属机构
                query:{
                    kcId:'',
                    ssjg:'',
                    tkmcWord:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'tkmc',
                        title: '题库名称'
                    },
                    {
                        field: 'jgmc',
                        title: '所属机构',
                        formatter: (value)=> {
                            return value || '公共';
                        }
                    },
                    {
                        field: 'kcmc',
                        title: '题库课程',
						formatter: (value,row)=> {
						    return row.kcdm+'-'+row.kcmc;
						}
                    },
                    {
                        field: 'tktb',
                        title: '题库图标',
                        formatter: (value)=> {
                            if(value){
                                return "<img src='"+value+"' style='width:50px;height:50px'>";
                            }
                            return '';
                        }
                    },
                    {
                        field: 'zt',
                        title: '状态',
                        formatter: (value)=> {
                            return value =='OK' ? '启用' : '关闭';
                        }
                    },
                    {
                        field: 'stsl',
                        title: '试题数量',
                        formatter: (value)=> {
                            return value || '';
                        }
                    },
                    {
                        field: 'cjyh',
                        title: '创建用户',
                        formatter: (value)=> {
                            return value || '';
                        }
                    },
                    {
                        field: 'cjsj',
                        title: '创建时间'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template: '<div class="operation_column"><a @click="previewSt(row)">预览试题</a> | ' +
                                    '<a @click="editSt(row)">修改</a> | '+
                                    '<a @click="delSt(row)">删除</a></div>',
                                data: { row },
                                methods: {
                                    previewSt: this.previewSt,
                                    editSt: this.editSt,
                                    delSt: this.delSt,
                                }
                            })
                        }
                    }
                ]
            }
        },
		  mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		  },
		  beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		  },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'题库管理'},{name:'题库列表'}]);
            this.ssjgList = [{value: 'BJG', text: '本机构'}, {value: 'QTJG', text: '其他机构'}, {value: 'GG', text: '公共'}];//所属机构
            this.ztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}];//状态
            this.gettkkcList();//课程下拉
        },
        methods: {
            //课程下拉
            gettkkcList:function(){
                this.$http.post('/htgl/zktk/tk/hqkc').then(res=>{
                    this.tkkcList = res.data;
                });
            },
            //预览试题
            previewSt:function(row){
				this.$refs.QuesBankViewQues.open({id:row.id});
            },
            //修改
            editSt:function (row) {
				this.$refs.QuesBankEdit.open({  id:row.id});
            },
            //删除
            delSt:function (row) {
                let ids = [];
                if(row){
                    ids.push(row.id);
                }
                else{
                    //批量删除
                    let selections = this.$refs.table.getSelections();
                    ids = selections.map(x=>{return x.id});
                }
                if(ids.length > 0){
                    ids = ids.join(",");
					this.$confirm('确定执行此操作吗？',()=>{
						this.$http.post("/htgl/zktk/tk/sc",{ids:ids}).then((res)=>{
						    if(res.data==true){
								this.$success('操作成功',()=>{
									this.search();//刷新列表
								});
						    }
						});
					});
                }
                else{
					this.$error('请选择一条数据记录');
                }
            },

			 search:function(){
				 //将数据表格的页码以及每一页展示的数据重置为1，10
				let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
			 },

            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/zktk/tk/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
			pageChange:function(pageNumber, pageSize){
				let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
			}
        }

    }
</script>
<style scoped>

</style>
